import {
    LIST_CHARACTERS,
    LIST_CHARACTERS_SUCCESS,
    LIST_CHARACTERS_ERROR,
    ADD_CHARACTERS,
    SAVE_CHARACTERS,
    SAVE_CHARACTERS_SUCCESS,
    SAVE_CHARACTERS_ERROR,
    EDIT_CHARACTERS,
    UPDATE_CHARACTERS,
    UPDATE_CHARACTERS_SUCCESS,
    UPDATE_CHARACTERS_ERROR,
    DELETE_CHARACTERS,
    DELETE_CHARACTERS_SUCCESS,
    DELETE_CHARACTERS_ERROR
} from '../types';

//Cada reducer tiene su propio state
const initialState = {
    characters: null,
    error: null,
    loading: false,
    characterSelected: null,
    isEdit: false,
    loadingSave: false,
    errorSave: null
}

export default function(state = initialState, action) {
    switch(action.type){
        case LIST_CHARACTERS:
            return {
                ...state,
                loading: true
            }
        case LIST_CHARACTERS_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case LIST_CHARACTERS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                characters: action.payload
            }
        case SAVE_CHARACTERS:
        case DELETE_CHARACTERS:
            return {
                ...state,
                isEdit: false,
                loadingSave: true
            }
        case UPDATE_CHARACTERS:
            return {
                ...state,
                loadingSave: true
            }
        case SAVE_CHARACTERS_ERROR:
        case UPDATE_CHARACTERS_ERROR:
        case DELETE_CHARACTERS_ERROR:
            return {
                ...state,
                loadingSave: false,
                errorSave: action.payload
            }
        case SAVE_CHARACTERS_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                characters: [...state.characters, action.payload]
            }
        case ADD_CHARACTERS:
            return {
                ...state,
                characterSelected: null,
                isEdit: false
            }
        case EDIT_CHARACTERS:
            return {
                ...state,
                characterSelected: action.payload,
                isEdit: true
            }
        case UPDATE_CHARACTERS_SUCCESS:
        case DELETE_CHARACTERS_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                characters: state.characters.map(character => 
                    character.id === action.payload.id ? character = action.payload : character
                ),
                characterSelected: null
            }
        // case DELETE_CHARACTERS_SUCCESS:
        //     return {
        //         ...state,
        //         loadingSave: false,
        //         errorSave: null,
        //         characters: state.characters.filter( character => character.id !== action.payload)
        //     }
        default:
            return state;
    }
}